import moment from 'moment';
import { IEventFilter, IPackageListingState } from '../classes/package-listing';
import { IProduction, IPackage } from '../custom/classes/production';
import { upsertEventFilter } from '../redux-state/actions/package-listing.actions';


export function AddFilterToQuery(currState: IPackageListingState<IPackage>): void {
    const serialized = serializeProps(currState);
    if (serialized.length > 0) {
        window.location.hash = encodeURI(serialized);
    }
}

function serializeProps(state: IPackageListingState<IPackage>): string {
    if (state.eventFilter.length < 1)
        return "";
    return JSON.stringify(state.eventFilter);
}


export function generateEventFilter(propertyToFilter: string, selectedValue: string) {
    return (production: IProduction) => {
        const propertyValue = production[propertyToFilter];
        // If it's an array, check if the value exists inside
        if (propertyValue.constructor === Array) {
            return (propertyValue as any[]).some(item => item === selectedValue);
        } else {
            return production[propertyToFilter].toString() === selectedValue
        }
    }
}
